module.exports = __webpack_public_path__ + "static/icons/icon-wave-7c3243f4c6637c41896e77fa7033314e.svg";